import { ActionContext } from 'vuex';

import { TBaseFilterPayload } from '@/common/types/filter';
import { getLocalState } from '@/common/utils/store';

import { TForeignTradeByProductsFilter } from '../../types/foreign-trade-by-products';
import { FOREIGN_TRADE_BY_PRODUCTS_ACTIONS_NAME } from './name';
import { TForeignTradeByProductsState } from './types';

import links from '@/utils/links';
import request from '@/utils/request';

export async function searchProductAggregated(
  context: ActionContext<TForeignTradeByProductsState, unknown>,
  payload: TBaseFilterPayload<TForeignTradeByProductsFilter>,
) {
  return request(
    context,
    {
      url: links.ved.foreignTrade.products.getProductAggregated,
      name: getLocalState(FOREIGN_TRADE_BY_PRODUCTS_ACTIONS_NAME.searchProductAggregated),
      abortController: payload.abortController,
      method: 'post',
    },
    payload.params,
  );
}
